import swup from "../entrypoints/swup";

const cartData = document.getElementById("cart-data");
const giftData = document.getElementById("gift-data");

export const store = {
  data: JSON.parse(cartData?.innerHTML ?? "{}"),
  threshold: cartData?.getAttribute("data-cart-threshold") ?? 200,
  visible: false,
  loading: false,
  container: document.querySelector("[data-cart-container]"),
  el: document.getElementById("cart"),

  gift: JSON.parse(giftData?.innerHTML ?? "{}"),
  giftThreshold: Number(giftData?.getAttribute("data-gift-threshold")),
  init() {
    window.Shopify.designMode && this.customizer();

    swup.hooks.on("visit:end", () => {
      if (this.visible && window.Alpine.store("productModal").visible) {
        //  this.close();
      }
    });

    swup.hooks.on("link:self", () => {
      if (this.visible) {
        this.close();
      }
    });

    let searchParams = new URLSearchParams(window.location.search);

    if (searchParams.get("cart")) {
      this.open();
    }
  },
  open() {
    this.container.scrollTo({ top: 0 });
    this.visible = true;
    document.body.style.overflow = "hidden";
  },
  close() {
    this.visible = false;
    document.body.style.overflow = "auto";
  },
  toggle() {
    if (this.visible) {
      this.close();
    } else {
      this.open();
    }
  },
  customizer() {
    document.addEventListener("shopify:section:select", (event) => {
      const { sectionId } = event.detail;
      if (sectionId.includes("cart")) {
        this.visible = true;
      }
    });

    document.addEventListener("shopify:section:deselect", () => {
      this.visible = false;
    });
  },
  async request(url, method = "GET", body) {
    return await fetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: body ? JSON.stringify(body) : undefined,
    }).then((r) => r.json());
  },
  async load() {
    return await this.request("/cart.js", "GET");
  },
  async updateLines(lineItems = {}) {
    if (this.loading) return;
    try {
      this.loading = true;
      this.data = await this.request("/cart/update.js", "POST", {
        updates: lineItems,
      });
    } finally {
      await setTimeout(() => {
        this.updateGiftItem();
      }, 1000)
      this.loading = false;
    }
  },
  async addLines(lineItems = []) {
    if (this.loading) return;
    try {
      this.loading = true;
      await this.request("/cart/add.js", "POST", {
        items: lineItems,
      });
    } catch (error) {
      throw Error(error);
    } finally {
      if (window.Alpine.store("productModal").visible) {
        window.Alpine.store("productModal").close(true, false);
      }
      this.data = await this.load();
      await setTimeout(() => {
        this.updateGiftItem();
      }, 1000)
      this.loading = false;

      if (this.visible) {
        this.container.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        this.open();
      }
    }
  },
  async replaceLines(removeKeys = [], addItems = []) {
    if (this.loading) return;
    try {
      this.loading = true;
      // Add the replacement first so the cart never momentarily empties (which
      // would trigger gift-with-purchase removal), then zero out the old lines.
      if (addItems.length) {
        await this.request("/cart/add.js", "POST", { items: addItems });
      }
      if (removeKeys.length) {
        const updates = Object.fromEntries(removeKeys.map((key) => [key, 0]));
        await this.request("/cart/update.js", "POST", { updates });
      }
      this.data = await this.load();
    } catch (error) {
      throw Error(error);
    } finally {
      await setTimeout(() => {
        this.updateGiftItem();
      }, 1000);
      this.loading = false;

      if (this.visible) {
        this.container.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        this.open();
      }
    }
  },
  get count() {
    if (!this.data) return 0;

    // Reset manually removed gift flag
    if (this.data?.item_count === 0) {
      window.sessionStorage.setItem('giftItemManuallyRemoved', 'false');
    }
    return this.data.item_count;
  },
  get hasItems() {
    if (!this.data) return false;
    return this.data.item_count > 0;
  },
  get totalPrice() {
    if (!this.data) return 0;
    // Calculate total excluding gift item
    const total = this.data.original_total_price;
    if (this.hasGiftItem) {
      const giftItem = this.items.find(item => item.id === this.gift?.variant_id);
      return total - (giftItem?.final_price || 0);
    }
    return total;
  },
  get subtotalPrice() {
    if (!this.data) return 0;
    // Calculate subtotal excluding gift item
    const subtotal = this.data.items_subtotal_price;
    if (this.hasGiftItem) {
      const giftItem = this.items.find(item => item.id === this.gift?.variant_id);
      return subtotal - (giftItem?.final_price || 0);
    }
    return subtotal;
  },
  get items() {
    if (!this.data) return [];
    return this.data.items || [];
  },
  get hasFreeShipping() {
    return this.freeShippingLeft <= 0;
  },
  get freeShippingLeft() {
    return this.threshold * 100 - this.totalPrice;
  },
  get freeShippingLeftPercentage() {
    const percentage =
      -100 + Math.round((this.totalPrice / (this.threshold * 100)) * 100);
    return Math.min(0, Math.max(-100, percentage));
  },
  // Gift With Purchase
  get giftItem() {
    if (!this.gift) return {};
    return this.gift?.variant_id || {};
  },
  get giftItemPrice() {
    return this.gift?.price || 0
  },
  get isGiftEligible() {
    // Check eligibility based on cart total excluding gift
    return this.giftThresholdLeft <= 0;
  },
  get giftThresholdLeft() {
    // Calculate threshold left based on cart total excluding gift
    return this.giftThreshold - this.totalPrice;
  },
  get hasGiftItem() {
    return this.items.some(item => item.id === this.gift?.variant_id);
  },
  async updateGiftItem() {
    console.log('GWP (Update):', {
      isEligible: this.isGiftEligible,
      hasGift: this.hasGiftItem,
      giftData: this.gift?.variant_id,
      thresholdLeft: this.giftThresholdLeft,
      cartTotal: this.totalPrice,
      giftPrice: this.gift?.price
    });

    // Check if gift item was manually removed
    const wasManuallyRemoved = window.sessionStorage.getItem('giftItemManuallyRemoved') === 'true';

    if (this.isGiftEligible && !this.hasGiftItem && !wasManuallyRemoved) {
      // Add gift item if eligible, not already in cart, and wasn't manually removed
      const giftLineItem = {
        id: this.gift?.variant_id,
        quantity: 1,
        properties: {
          _gift_with_purchase: 'true'
        }
      };
      console.log('Attempting to add gift item:', giftLineItem);
      await this.addLines([giftLineItem]);
    } else if (!this.isGiftEligible && this.hasGiftItem) {
      // Remove gift item if not eligible and present in cart
      const giftItem = this.items.find(item => item.id === this.gift?.variant_id);
      if (giftItem) {
        await this.updateLines({ [giftItem.key]: 0 });
        // Clear the manually removed flag when gift is removed due to ineligibility
        window.sessionStorage.removeItem('giftItemManuallyRemoved');
      }
    }
  }
};
